export default __webpack_public_path__ + "static/media/interview.a38416a9.png";